import DashboardGlobal from './dashboard/DashboardGlobal';

const modules = [
	DashboardGlobal
]

export default modules;